import { useMemo } from 'react';
import { type ColumnDef } from '@tanstack/react-table';
import { PageHeader } from '@/components/layout/PageHeader';
import { DataTable } from '@/components/ui/DataTable';
import { Badge } from '@/components/ui/Badge';
import { useAudit } from '@/hooks/useDispatcher';
import { formatDateTime } from '@/lib/utils';
import type { AuditEntry } from '@/types/api';

export default function AuditPage() {
  const { data, isLoading } = useAudit();

  const columns = useMemo<ColumnDef<AuditEntry>[]>(
    () => [
      { accessorKey: 'ts', header: 'Date', cell: ({ getValue }) => formatDateTime(getValue<string>()) },
      { accessorKey: 'actor_email', header: 'Acteur', cell: ({ getValue }) => getValue<string>() ?? 'system' },
      {
        accessorKey: 'actor_role',
        header: 'Rôle',
        cell: ({ getValue }) =>
          getValue<string>() ? <Badge tone="brand">{getValue<string>()}</Badge> : <span>—</span>,
      },
      { accessorKey: 'action', header: 'Action' },
      { accessorKey: 'target_type', header: 'Cible', cell: ({ getValue }) => getValue<string>() ?? '—' },
      {
        accessorKey: 'target_id',
        header: 'ID cible',
        cell: ({ getValue }) => <span className="font-mono text-xs">{getValue<string>() ?? '—'}</span>,
      },
    ],
    [],
  );

  return (
    <div>
      <PageHeader title="Audit" description="Journal des actions sur le Dispatcher" />
      <DataTable
        data={data}
        columns={columns}
        loading={isLoading}
        searchPlaceholder="Filtrer par action, acteur, cible…"
        emptyTitle="Aucune entrée d'audit"
      />
    </div>
  );
}
